/** Never treat a proxy HTML page, redirect or truncated JSON as successful API data. */
export async function decodeApiResponse(response:Response):Promise<{valid:boolean;data:any}>{
 if(response.status===204)return {valid:true,data:null};
 if(!/^application\/(?:[\w.+-]+\+)?json(?:\s*;|$)/i.test(response.headers.get('content-type')||''))return {valid:false,data:null};
 try{return {valid:true,data:await response.json()}}catch{return {valid:false,data:null}}
}
